import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  Warning,
  CheckCircle,
  Publish as PublishIcon,
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  warningBox: {
    backgroundColor: theme.palette.warning.light,
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  changesList: {
    marginTop: theme.spacing(2),
  },
  publishButton: {
    backgroundColor: theme.palette.success.main,
    color: "#fff",
    "&:hover": {
      backgroundColor: theme.palette.success.dark,
    },
  },
}));

const PublishConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  changes = [],
}) => {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle className={classes.dialogTitle}>
        <Box display="flex" alignItems="center" gap={1}>
          <PublishIcon />
          <Typography variant="h6">Confirmar Publicación</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box className={classes.warningBox}>
          <Warning color="inherit" />
          <Typography variant="body2">
            Esta acción publicará los cambios y los hará visibles para todos
            los visitantes de la landing page.
          </Typography>
        </Box>

        {changes.length > 0 && (
          <Box className={classes.changesList}>
            <Typography variant="subtitle2" gutterBottom>
              Cambios a publicar:
            </Typography>
            <List dense>
              {changes.map((change, index) => (
                <ListItem key={index}>
                  <ListItemIcon>
                    <CheckCircle color="primary" fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary={change} />
                </ListItem>
              ))}
            </List>
          </Box>
        )}

        <Divider style={{ margin: "16px 0" }} />

        <Typography variant="body2" color="textSecondary">
          Se creará una copia de seguridad de la versión actual antes de
          publicar. Podrás revertir los cambios desde el historial de versiones
          si es necesario.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="default">
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          className={classes.publishButton}
          variant="contained"
          startIcon={<PublishIcon />}
        >
          Confirmar Publicación
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PublishConfirmationModal;
